import Stripe from 'stripe';

import { StripePaymentMethod } from 'src/types/payment';

export type MicrodepositType = 'amounts' | 'descriptor_code';

export const DEFAULT_MICRODEPOSIT_TYPE: MicrodepositType = 'amounts';

export const resolveMicrodepositType = (
  microdepositType?: MicrodepositType | '' | null,
): MicrodepositType =>
  microdepositType === 'descriptor_code'
    ? 'descriptor_code'
    : DEFAULT_MICRODEPOSIT_TYPE;

export interface BankVerifyFormModel {
  fromAmount: string;
  toAmount: string;
  descriptorCode: string;
  microdepositType: MicrodepositType;
  id: Stripe.BankAccount['id'];
  last4: Stripe.BankAccount['last4'];
  bank_name: Stripe.BankAccount['bank_name'];
}

export type PaymentsDetails = {
  defaultSource: string;
  sources: StripePaymentMethod[];
  modalRenderer: (options?: { formOnly?: boolean }) => React.ReactNode;
  isSourcesLoading: boolean;
  makePrimaryMethod: (source: StripePaymentMethod) => void;
  handleDelete: (sourceId: string) => void;
  openAddPaymentModal: () => void;
  handleVerify: (values: BankVerifyFormModel) => Promise<void>;
  bankAccounts?: Record<string, Stripe.BankAccount>;
};
